import { Group, Title, Text } from "@mantine/core"
import { CountryLabel } from "@tfg/ui"
import { useTranslation } from "react-i18next"

import { LibraryResponses } from "@tfg/types/endpoints/library"

import { COUNTRIES } from "~/utils/countries.ts"

interface Props {
  productionSite: LibraryResponses.SupplierMonitoring["productionSites"][number]
  title: boolean
}

export const ProductionSiteCard = ({ productionSite, title }: Props) => {
  const { t } = useTranslation("suppliers")

  return (
    <Group>
      {title ? (
        <Title
          order={2}
          lineClamp={1}
          style={{
            textOverflow: "ellipsis",
            overflow: "hidden",
            whiteSpace: "nowrap",
            fontWeight: "bold",
          }}
        >
          {productionSite.name}
        </Title>
      ) : (
        <Text style={{ fontWeight: "bold" }}> {productionSite.name}</Text>
      )}
      <CountryLabel
        countryIso3166={productionSite.countryIso3166}
        countriesMapper={COUNTRIES}
      />
      {productionSite.address ? (
        <Text size="xs" style={{ textTransform: "capitalize" }}>
          {productionSite.address.toLowerCase()}
        </Text>
      ) : (
        <Text size="xs" c="gray">
          {t("list.noAddress")}
        </Text>
      )}
    </Group>
  )
}
